// Etichette del preventivo condomini: approvate da Alfonso il 22/10 e il 23/10 (spec § 11 e registro del lavoro). Tenute qui perché si cambiano senza toccare i componenti.

export const NON_LETTA = "Non letta";
export const NON_LETTA_CONSUMI = "Non letta: nella foto mancano i consumi";
export const PIU_FORNITURE = "Questa bolletta ha più di una fornitura luce";
export const FILE_NON_ACCETTATO = "File non accettato: solo PDF, JPG o PNG fino a 10 MB";
// «non ancora disponibile» si leggeva come lettura in corso: Alberto ha aspettato un'analisi che non arriva (Alfonso 28/10)
export const GAS_FUORI = "Gas: il preventivo per ora confronta solo la luce.";
// apertura del preventivo vuoto (Alfonso 23/10 sera, rivista con la skill di italiano)
export const APERTURA = "Le bollette della luce dei condomìni a confronto con le offerte a prezzo variabile.";
export const APERTURA_PASSI = [
  "Si caricano le bollette, in foto o in PDF: una per foto, anche molte insieme.",
  "Ogni bolletta si legge in circa 45 secondi: i risultati compaiono man mano.",
  "Per ogni condominio: spread, ricarichi non dichiarati, altri addebiti e il risparmio al mese con l'offerta scelta.",
] as const;
export const TEMPO_LETTURA = "Circa 45 secondi a bolletta. Si può continuare a usare la pagina.";
export const INVIO_NON_RIUSCITO = "Invio non riuscito";
export const COLLEGAMENTO_NON_RIUSCITO = "Collegamento non riuscito";
export const RIPROVA = "Riprova";
export const ELIMINA = "Elimina";
// la conferma prima di cancellare una bolletta (Alfonso 03/11); `mese` è il mese della bolletta, `null` se non letto
export function titoloEliminaBolletta(mese: string | null): string {
  return mese ? `Eliminare la bolletta di ${mese}?` : "Eliminare questa bolletta?";
}
export const TESTO_ELIMINA_BOLLETTA = "Si cancellano il file e la sua lettura. Non si torna indietro.";
/** Il nome di «Elimina» per il lettore di schermo: nella pagina ce n'è uno per bolletta. */
export function nomeEliminaBolletta(mese: string | null): string {
  return mese ? `Elimina la bolletta di ${mese}` : "Elimina la bolletta";
}
export const NESSUNA_OFFERTA = "Nessuna offerta a prezzo variabile in vendita per la tua agenzia.";

// Tabella unica e schede (spec 2026-10-23 §§ 3 e 5, approvate il 23/10).
export const COL_PCV = "PCV €/mese";
export const COL_SPREAD = "Spread dichiarato €/kWh";
export const COL_RICARICO = "Ricarico non dichiarato in bolletta";
export const COL_ALTRI = "Altri addebiti";
/** Intestazione combinata della tabella compatta (25/10), al posto di «Mese» e «Fornitura». */
export const COL_MESE_FORNITURA = "Mese · fornitura";
export const COL_DIFFERENZA = "Differenza al mese";
/** Sotto le spese per insoluto in «Altri addebiti». */
export const FUORI_CONFRONTO = "fuori dal confronto";
/** Tre stati della cella dello spread senza valore stampato (Alfonso 28/10): sotto «—» nella scheda, o nella riga delle note. */
export const SPREAD_NON_DICHIARATO = "non dichiarato";
export const SPREAD_CALCOLATO = "non dichiarato, calcolato dalla bolletta";
export const SPREAD_NON_LETTO = "non letto";
// Riga delle note sotto la bolletta, nella tabella (mockup «impaginazioni», variante A scelta da Alfonso)
export const NOTA_SPREAD = "Spread:";
export const NOTA_RICARICO = "Ricarico:";
export const NOTA_ALTRI = "Altri addebiti:";
// Bolletta a cui manca un dato (mockup «bolletta incompleta», approvato il 24/10): solo queste frasi
export const AGGIUNGI_PAGINA = "Aggiungi pagina";
export const NOTA_DIFFERENZA = "Differenza:";
export const NOTA_RETE = "Rete e oneri:";
export const RETE_COME_IN_BOLLETTA = "come in bolletta, manca la potenza impegnata";
export const MANCANO_CONSUMI = "mancano i consumi";
export const MANCA_POTENZA = "manca la potenza impegnata";
/** Per `tipo_cliente_non_letto` nessuna frase approvata: la cella dice «—» e basta, nessuna nota inventata. */
export function motivoDifferenza(motivo: string | null): string | null {
  if (motivo === "lettura_incompleta" || motivo === "periodo_non_letto") return MANCANO_CONSUMI;
  if (motivo === "potenza_non_letta") return MANCA_POTENZA;
  return null;
}

/** Nella riga delle note, l'offerta di una fornitura che ne ha una sua (Alfonso 24/10, giro 4 del link). */
export const NOTA_OFFERTA = "Offerta:";

/** La freccia a inizio riga della bolletta (aria-label) e, col numero, la riga da aprire delle schede. */
export const ADDEBITI_IN_PIU = "Addebiti in più";

export function addebitiInPiu(n: number): string {
  return `${ADDEBITI_IN_PIU} (${n})`;
}

/** Riga da aprire con le bollette dalla quarta in poi: `n` è il totale del condominio. */
export function leBollette(n: number): string {
  return `Le ${n} bollette`;
}

// Scelta dell'offerta (spec § 11, «Offerta del condominio» e «Righe di stato»).
export const OFFERTA_CONDOMINIO = "Offerta del condominio";
/** Il menù della quota fissa dell'offerta (spec § 8: «Quota fissa» diventa «PCV»). */
export const MENU_PCV = "PCV";
export const SCEGLI_OFFERTA = "Scegli l'offerta";
export const TORNA_CONDOMINIO = "Torna all'offerta del condominio";
export const FATTO = "Fatto";
export const SOLO_QUESTA_FORNITURA = "Offerta solo per questa fornitura";
// al posto delle celle che lampeggiano mentre l'analisi lavora (Alfonso 24/10)
export const IN_ANALISI = "in analisi";
export const SOLO_QUESTA = "solo per questa fornitura";   // Alfonso 24/10: «· solo questa» non si capiva

/** «1 fornitura ha un'offerta diversa e resta com'è» e il plurale. */
export function fornitureDiverse(n: number): string {
  return n === 1
    ? "1 fornitura ha un'offerta diversa e resta com'è"
    : `${n} forniture hanno un'offerta diversa e restano come sono`;
}

/** Motivo di «Non letta» in parole. Solo i motivi con un testo approvato hanno la frase;
 * per gli altri resta «Non letta» da sola: nessuna spiegazione inventata. */
export function testoNonLetta(motivo: string | null): string {
  if (motivo === "lettura_incompleta" || motivo === "periodo_non_letto") return NON_LETTA_CONSUMI;
  if (motivo === "piu_forniture") return PIU_FORNITURE;
  if (motivo === "pdr_non_letto") return PDR_NON_LETTO;
  return NON_LETTA;   // anche `pdr_diversi` (più PDR delle forniture gas lette): nessuna frase approvata, quindi nessuna spiegazione inventata
}

/** «Rifai la foto» serve solo quando un'altra foto può dare la lettura: non a una bolletta
 * con due forniture luce, che resta tale. */
export function rifareAiuta(motivo: string | null): boolean {
  return motivo !== "piu_forniture";
}

export function conteggio(bollette: number, condomini: number): string {
  const b = bollette === 1 ? "1 bolletta" : `${bollette} bollette`;
  const c = condomini === 1 ? "1 condominio" : `${condomini} condomìni`;
  return `${b} · ${c}`;
}

/** «1 letta su 2», «2 lette su 3». */
export function lette(n: number, su: number): string {
  return `${n} ${n === 1 ? "letta" : "lette"} su ${su}`;
}

// Fotografare una bolletta di più pagine dal telefono (mockup foto-bollette, variante A approvata il 24/10)
/** Sotto i comandi spenti e sulla riga non accettata: il tetto di bollette per preventivo (Alfonso 25/10). `massimo` arriva dal server. */
export function raggiuntoMassimo(massimo: number): string {
  return `Raggiunto il massimo di ${massimo} bollette`;
}

export const FOTOGRAFA = "Fotografa una bolletta";
export const CARICA_DAL_TELEFONO = "Carica PDF o foto dal telefono";
/** Stessa azione, per il Fold aperto (640-1023 px), dove il pulsante è nel 2fr della riga. */
export const CARICA_BREVE = "Carica PDF o foto";
export const BOLLETTA_NUOVA = "Bolletta nuova";
export const FOTOGRAFA_ALTRA = "Fotografa un'altra bolletta";   // quando nel preventivo c'è già una bolletta (Alfonso 25/10)
export const ALTRA_PAGINA = AGGIUNGI_PAGINA;
export const BOLLETTA_FINITA = "Analizza la bolletta";

/** Non è una scritta: l'id dell'elenco «Bollette caricate», dove porta il tocco sulla striscia. */
export const ELENCO_BOLLETTE = "elenco-bollette";
// Striscia di stato fissa in alto sul telefono (mockup «stato telefono», variante B approvata il 25/10)
export function bolletteInAnalisi(n: number): string {
  return n === 1 ? "1 bolletta in analisi" : `${n} bollette in analisi`;
}
export function pronteSu(pronte: number, su: number): string {
  return `${pronte} pronte su ${su}`;
}
export const IN_INVIO = "In invio";
export const ANNULLA = "Annulla";
export const ANNULLA_BOLLETTA = "Annulla la bolletta";
export const TORNA_ALLE_FOTO = "Torna alle foto";

/** «1 pagina», «3 pagine». */
export function pagine(n: number): string {
  return n === 1 ? "1 pagina" : `${n} pagine`;
}

/** La riga della bolletta fotografata col telefono, che non ha un nome di file: «Foto · 3 pagine». */
export function fotoPagine(n: number): string {
  return `Foto · ${pagine(n)}`;
}

/** Solo per il lettore dello schermo: la × sulla miniatura. */
export function togliPagina(n: number): string {
  return `Togli la pagina ${n}`;
}

/** La conferma di «Annulla» con le pagine già scattate. */
export function paginePerse(n: number): string {
  return n === 1 ? "La pagina scattata si perde." : `Le ${n} pagine scattate si perdono.`;
}

// «Tutti i condomìni» e «Stessa offerta per tutti» (mockup totale-condomini, approvato il 24/10)
export const TUTTI_CONDOMINI = "Tutti i condomìni";
export const STESSA_OFFERTA = "Stessa offerta per tutti";
/** Nella barra del telefono quando accanto c'è «Invia» (Alfonso, 29/10). */
export const STESSA_OFFERTA_BREVE = "Stessa offerta";

/** «7 condomìni · 16 forniture». */
export function condominiForniture(condomini: number, forniture: number): string {
  const c = condomini === 1 ? "1 condominio" : `${condomini} condomìni`;
  const f = forniture === 1 ? "1 fornitura" : `${forniture} forniture`;
  return `${c} · ${f}`;
}

/** «su 5 dei 7 condomìni»: il totale non li conta tutti (come «su X delle Y forniture»). */
export function suCondomini(contati: number, totali: number): string {
  return `su ${contati} dei ${totali} condomìni`;
}

// Il gas nel condominio (giro 1 del gas, scritte approvate da Alfonso il 26/10): solo queste.
export const PDR_NON_LETTO = "PDR non letto";
export const GAS_SENZA_CONFRONTO = "senza confronto con le offerte";
export const GAS_NON_RIUSCITA = "Voci del gas non controllate: analisi non riuscita";
const MESI_ESTESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];

/** «Luce · Unoenergy», «Gas · Hera Comm»; senza venditore solo il tipo. Il tipo è sempre scritto: il colore da solo non basta. */
export function tipoVenditore(tipo: "Luce" | "Gas", venditore: string | null): string {
  return venditore ? `${tipo} · ${venditore}` : tipo;
}

/** «1 fornitura», «2 forniture» (il numero non va a capo senza il suo nome). */
export function fornitureN(n: number): string {
  return n === 1 ? "1\u00a0fornitura" : `${n}\u00a0forniture`;
}

/** «Voci del gas non controllate: mancano i valori ufficiali di ottobre, caricati il 5 novembre»; `mese` è «2026-10». */
export function gasValoriMancanti(mese: string): string {
  const m = Number(mese.split("-")[1]);
  return `Voci del gas non controllate: mancano i valori ufficiali di ${MESI_ESTESI[m - 1]}, caricati il 5 ${MESI_ESTESI[m % 12]}`;
}

// Allegati condivisi da WhatsApp (mockup «condividi», impaginazione B, approvate da Alfonso il 27/10): solo queste.
export function bolletteRicevute(n: number): string {
  return n === 1 ? "1 bolletta ricevuta" : `${n} bollette ricevute`;
}
export const NUOVO_PREVENTIVO = "Nuovo preventivo";
export const ALLEGATI_NON_RICEVUTI = "Allegati non ricevuti. Condividili di nuovo da WhatsApp.";

/** «Condominio A, Condominio B»; oltre i due: «A, B e altri 3». */
export function nomiCondomini(titoli: string[]): string {
  if (titoli.length <= 2) return titoli.join(", ");
  const altri = titoli.length - 2;
  return `${titoli[0]}, ${titoli[1]} e ${altri === 1 ? "un altro" : `altri ${altri}`}`;
}

const due = (n: number) => String(n).padStart(2, "0");
const giorno = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/** «ultimo caricamento oggi, 13:39» / «ieri, 21:30» / «il 25/10, 17:01»: giorno e ora del telefono, 24 ore. */
export function ultimoCaricamento(iso: string, adesso: Date = new Date()): string {
  const t = new Date(iso);
  const ora = `${due(t.getHours())}:${due(t.getMinutes())}`;
  const giorniFa = Math.round((giorno(adesso) - giorno(t)) / 86_400_000);
  const quando = giorniFa === 0 ? "oggi" : giorniFa === 1 ? "ieri" : `il ${due(t.getDate())}/${due(t.getMonth() + 1)}`;
  return `ultimo caricamento ${quando}, ${ora}`;
}

/** Nella pagina di accesso, se si arriva da una condivisione con file in attesa. */
export function dopoAccesso(n: number): string {
  return n === 1
    ? "Dopo l'accesso la bolletta va nel preventivo condomini."
    : `Dopo l'accesso le ${n} bollette vanno nel preventivo condomini.`;
}
